export default __webpack_public_path__ + "static/media/loading-skull-nounbr.d7293d44.gif";